// extracted by mini-css-extract-plugin
module.exports = {"root":"LimitedAccessBanner_root__y_Tdb","text":"LimitedAccessBanner_text__2BeqJ","button":"LimitedAccessBanner_button__2cM5I"};